import { DateTime } from 'luxon';

declare global {
    interface String {
        removerHTML(): string;
        cortar(limite: number): string;
        data(): DateTime;
        slug(): string;
        moeda(): string;
        segundosParaTempo(): string;
    }
}

String.prototype.removerHTML = function()
{
    return this.replace(/(<([^>]+)>)/ig,'');
}

String.prototype.cortar = function(limite: number): string
{
    const texto = String(this);

    if (texto.length >= limite) {
        return texto.substring(0, limite) + '...';
    }

    return texto;
}

String.prototype.data = function(): DateTime
{
    return DateTime.fromISO(String(this)).setLocale('br');
}

String.prototype.slug = function (): string
{
    return this.toString().toLowerCase()
        .replace(/[àÀáÁâÂãäÄÅåª]+/g, 'a')
        .replace(/[èÈéÉêÊëË]+/g, 'e')
        .replace(/[ìÌíÍîÎïÏ]+/g, 'i')
        .replace(/[òÒóÓôÔõÕöÖº]+/g, 'o')
        .replace(/[ùÙúÚûÛüÜ]+/g, 'u')
        .replace(/[ýÝÿŸ]+/g, 'y')
        .replace(/[ñÑ]+/g, 'n')
        .replace(/[çÇ]+/g, 'c')
        .replace(/[ß]+/g, 'ss')
        .replace(/[Ææ]+/g, 'ae')
        .replace(/[Øøœ]+/g, 'oe')
        .replace(/[%]+/g, 'pct')
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}

String.prototype.moeda = function()
{
    return `R$${new Number(this).toFixed(2)}`;
}

String.prototype.segundosParaTempo = function()
{
    const sec_num = parseInt(this as string, 10);

    let hours = (Math.floor(sec_num / 3600)).toString();
    let minutes = (Math.floor((sec_num - (parseInt(hours) * 3600)) / 60)).toString();
    let seconds = (sec_num - (parseInt(hours) * 3600) - (parseInt(minutes) * 60)).toString();

    if (parseInt(hours) < 10) hours = '0' + hours;
    if (parseInt(minutes) < 10) minutes = '0' + minutes;
    if (parseInt(seconds) < 10) seconds = '0' + seconds;

    return hours+':'+minutes+':'+seconds;
}
